<template>
    <div>
        <form action="#l" method="post">
            <div class="title-container">
                <h2 class="search-title">{{ searchboxheadlineflightluggage[getCurrentLocale] }}</h2>
                <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
                <i class="soap-icon-baggage-status"></i>
            </div>


            <div class="search-content">
                <div id="main" class="col-md-12">
                    <h4 class="skin-color">{{ luggagetitle[getCurrentLocale] }}</h4>
                    <p v-html="luggagetext1[getCurrentLocale]"></p>
                    <br />
                    <div class="contact-address block">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="icon-box style5">
                                    <i class="soap-icon-baggage-status"></i>
                                    <div class="description" style="padding-top: 6px;">
                                        <h5 style="margin-bottom: 5px;">
                                            {{ handluggage[getCurrentLocale] }} (1 {{ piece[getCurrentLocale] }})<br />
                                            {{ dimensions[getCurrentLocale] }}: max. 55cm x 40cm x 20cm , {{ weight[getCurrentLocale] }}: max. 6kg
                                        </h5>
                                        <a href="/infos-luggage/#/luggage" title="" class="button sundair" target="_new">{{ moreinfo[getCurrentLocale] }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="contact-address block">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="icon-box style5">
                                    <i class="soap-icon-baggage-status"></i>
                                    <div class="description" style="padding-top: 6px;">
                                        <h5 style="margin-bottom: 5px;">
                                            {{ abandonableluggage[getCurrentLocale] }} (1 {{ piece[getCurrentLocale] }})<br />
                                            {{ weight[getCurrentLocale] }}: max. 20kg
                                        </h5>
                                        <a href="/infos-luggage/#/luggage" title="" class="button sundair" target="_new">{{ moreinfo[getCurrentLocale] }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h4 v-html="luggagetext3[getCurrentLocale]"></h4>
                </div>


                <div id="honeymoon1" class="tab-pane fade in active image-style style2">
                    <div class="row">
                        <div class="col-md-12 column-in-center">
                            <ul style="" class="image-block clearfix">
                                <li style="z-index: 5; left: 50px; top; 10px;">
                                    <a style="width: 80px; height: 80px; position: relative;"
                                        class="middle-block" href="/services">
                                        <img width="133" height="88" alt="" src="/res/images/services/seats/tabs_banner_5.png"
                                            class="middle-item"
                                            style="position: absolute; top: 50%; margin-top: -40px; left: 50%; margin-left: -66.5px;">
                                    </a>
                                </li>
                                <li style="z-index: 4; left: 180px; top: 100px;">
                                    <a style="width: 100px; height: 100px; position: relative;"
                                        class="middle-block" href="/services">
                                        <img width="150" height="100" alt="" src="/res/images/services/seats/tabs_banner_4.jpg"
                                            class="middle-item"
                                            style="position: absolute; top: 50%; margin-top: -50px; left: 50%; margin-left: -75px;">
                                    </a>
                                </li>
                                <li style="z-index: 3; left: 250px; top: 20px;">
                                    <a style="width: 150px; height: 150px; position: relative;"
                                        class="middle-block" href="/services">
                                        <img width="220" height="196" alt="" src="/res/images/services/seats/tabs_banner_2.png"
                                            class="middle-item"
                                            style="position: absolute; top: 50%; margin-top: -75px; left: 50%; margin-left: -110px;">
                                    </a>
                                </li>
                                <li style="z-index: 2; left: 100px; top: 0;">
                                    <a style="width: 160px; height: 160px; position: relative;"
                                        class="middle-block" href="/services">
                                        <img width="312" height="208" alt="" src="/res/images/services/seats/tabs_banner_3.png"
                                            class="middle-item"
                                            style="position: absolute; top: 50%; margin-top: -80px; left: 50%; margin-left: -156px;">
                                    </a>
                                </li>
                                <li style="z-index: 1; left: 0; top: 30px;">
                                    <a style="width: 156px; height: 156px; position: relative;"
                                        class="middle-block" href="/services">
                                        <img width="235" height="156" alt="" src="/res/images/services/seats/tabs_banner_1.jpg"
                                            class="middle-item"
                                            style="position: absolute; top: 50%; margin-top: -78px; left: 50%; margin-left: -117.5px;">
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <br /><br /><br />
                    <a href="/services" class="button btn-medium icon-check uppercase full-width">{{ seatsbutton[getCurrentLocale] }}</a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {

        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                searchboxheadlineflightluggage: {
                    en: 'Luggage',
                    de: 'Gepäck',
                },
                searchboxheadlineflights2: {
                    en: 'Discover the world with SUNDAIR!',
                    de: 'Entdecke die Welt mit SUNDAIR!',
                },
                // >>> --------------------------
                luggagetitle: {
                    en: 'Take extra luggage with you!',
                    de: 'Nehmen Sie zusätzliches Gepäck mit!',
                },
                luggagetext1: {
                    en: 'Your free luggage allowance includes <b>one (1) Cabin baggage and one (1) checked baggage free of charge per person.</b>',
                    de: 'Ihr Reisegepäck umfasst <b>ein kostenloses Handgepäck und ein kostenloses aufzugebendes Gepäck pro Person</b>.',
                },
                luggagetext3: {
                    en: "You need more luggage? <a href='/services'>Book additional baggage here.</a>",
                    de: 'Sie benötigen weiteres Gepäck? <a href="/services">Buchen Sie zusätzliches Gepäck hier.</a>',
                },
                weareon : {
                    en: 'Customer Service Department',
                    de: 'Abt. Kundenservice',
                },
                // >>> --------------------------
                seatsbutton: {
                    en: 'Directly to service booking',
                    de: 'Direkt zur Service Buchung',
                },
                // >>> --------------------------
                furtherservices_seat_comfortseat: {
                    en: 'Seats in the 1st row with plenty of legroom',
                    de: 'Sitzplätze in der 1. Reihe mit viel Beinfreiheit',
                },
                furtherservices_seat_comfortseat: {
                    en: 'Seats in the 1st row with plenty of legroom',
                    de: 'Sitzplätze in der 1. Reihe mit viel Beinfreiheit',
                },
                furtherservices_seat_bestseat: {
                    en: 'Seats in the 2nd - 7th row',
                    de: 'Sitzplätze in der 2.-7. Reihe',
                },
                furtherservices_seat_exitseat: {
                    en: 'Seats in the 12th and 14th row directly at the exit',
                    de: 'Sitzplätze in der 12. Und 14. Reihe direkt am Ausgang',
                },
                moreinfo: {
                    en: 'MORE INFO',
                    de: 'MEHR INFOS',
                },
                weight: {
                    en: 'Weight',
                    de: 'Gewicht'
                },
                dimensions: {
                    en: 'Dimensions',
                    de: 'Abmessungen'
                },
                handluggage: {
                    en: 'CABIN BAGGAGE',
                    de: 'HANDGEPÄCK'
                },
                abandonableluggage: {
                    en: 'CHECKED BAGGAGE',
                    de: 'AUFZUGEBENDES GEPÄCK'
                },
                piece: {
                    en: 'piece',
                    de: 'Stück'
                }
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .md-section {
        padding-top: 0px;
    }

    .image-style {
        padding-top: 10px;
        padding-right: 0px;
        padding-bottom: 10px;
        padding-left: 10px;
    }

    .column-in-center{
        margin-left: 60px;
    }



    .image-box.style9 figure img {
        width: 50%
    }

    a.button {
        background: #ec008b;
    }

    .icon-box.style5 > i {
        background: #ec008b;
    }
    .icon-box.style5 {
        background: #f5f5f5;
    }


    .block {
        margin-bottom: 20px;
    }



    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        .column-in-center {
            margin-left: 0px;
        }
        .icon-box.style5 > i {
            width: 80px;
            line-height: 80px;
        }
        .icon-box.style5 {
            height: 80px;
            line-height: 80px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/forms/LuggageTab.vue